// When a worm was put into a round that was already going (a "worm_spawned"
// game event: Back in, after a crash; or dropping into a running round), so the
// head renderers can pulse it like the round's start and its owner finds it.
// The events are read once each: a cache per game state remembers how far it got.
var caches = new WeakMap();

export var SPAWN_SPOTLIGHT_DURATION = 2; // seconds the new worm's pulses keep starting

export function spawnedAt(gameState, wormId) {
    var events = gameState && gameState.gameEvents;
    if (!events) return undefined;
    var c = caches.get(gameState);
    if (!c) {
        c = { seen: 0, at: {} };
        caches.set(gameState, c);
    }
    for (; c.seen < events.length; c.seen++) {
        var e = events[c.seen];
        if (e && e.type === "worm_spawned") c.at[e.wormId] = e.time;
    }
    return c.at[wormId];
}
